export default function LoadingDots() {
  return (
    <div className="flex gap-1">
      <div className="w-2 h-2 rounded-full bg-foreground animate-[pulse_1s_ease-in-out_infinite]" />
      <div className="w-2 h-2 rounded-full bg-primary animate-[pulse_1s_ease-in-out_infinite_0.3s]" />
      <div className="w-2 h-2 rounded-full bg-foreground animate-[pulse_1s_ease-in-out_infinite_0.6s]" />
    </div>
  );
}
